export const REPORTS_TRANSLATIONS = {
  Reports: "Rapoarte",

  lastReports: "Ultimele {{count}} rapoarte",
  lastReports_zero: "Nu există rapoarte",
  lastReports_one: "Ultimul raport",
  generalAnimalsReport: "Raport General Animale",
  generalAnimalsReportDescription:
    "Vizualizați și gestionați rapoartele legate de efectivul de animale al fermei.",
  individualAnimalReports: "Rapoarte individuale animale",
  individualAnimalReportsDescription:
    "Generați rapoarte detaliate despre un animal, reproducere, sǎnǎtate şi productivitate.",
  report_type_farm: "Raport Fermă",
  report_type_apiary: "Raport Stupină",
  report_type_crops: "Raport Culturi",
  report_type_farm_animals: "Raport General Animale",
  report_type_individual_animal: "Raport Individual Animal",
  newReport: "Raport Nou",
  download: "Descarcă",
  view: "Vizualizează",
  generateReport: "Generează raport",
}
